export default {
    /* Card Order */
    orderCard: 'Bestill kort',
    orderCardErrorBlockCardSuccess:
        'Kortet er sperret, men noe gikk galt med bestillingen av et nytt kort. Prøv igjen, eller ta kontakt med banken din for å fullføre bestillingen.',
    userDoesNotOwnAccountOrderCardInfo:
        'Dette er en konto du ikke eier. Derfor kreves det en manuell gjennomgang av bestillingen. Du vil motta en SMS når bestillingen er gjennomført.',
    verifyContactInfoAttentionMessage:
        'Pass på å sjekke at kontaktinformasjonen er riktig. Er den feil må du ta kontakt med banken.',
    orderCardStep0Legend: 'Vil du bestille et kort?',
    signAndOrder: 'Signer og bestill',
    goBackToCards: 'Gå tilbake til Kort',
    signingOrderUnknownStatusError: 'Feil ved henting av status',
    orderCardFormSummaryTitle: 'Kort oppsummert',
    orderCardStep0DebetCard: 'Jeg vil bestille et bankkort',
    orderCardStep0Reorder: 'Jeg vil erstatte et eksisterende kort',
    orderCardStep0CreditCard: 'Jeg vil søke om kredittkort',
    orderCardTitle: 'Bestill bankkort',
    orderCardUserIsNotOwnerTitle: 'Bestill bankkort til felleskonto',
    orderCardStep1Legend: 'Hvilken konto ønsker du å bestille kort til?',
    orderCardStep1UserIsNotOwnerLegend: 'Hvilken felleskonto ønsker du å bestille kort til?',
    orderCardStep1LegendOld: 'Bestill bankkort',
    orderCardStepDescription: 'Normalt sett vil du motta nytt kort innen en ukes tid.',
    orderCardStep0UserIsNotOwnerDescription: 'Hvilken felleskonto ønsker du å bestille kort til?',
    orderCardStep0Description: 'Hvilken konto ønsker du å bestille kort til?',
    orderCardStep1Warning: 'Kortet du erstatter blir sperret med en gang før vi bestiller et nytt.',
    orderCardStep2Legend: 'Hva er årsaken til at du ønsker kortet ditt sperret permanent?',
    orderCardReplaceTitle: 'Erstatt kort',
    orderCardReplaceDescription: 'Velg hvilket kort du vil erstatte',
    orderCardBankCardOption: 'Bestill nytt bankkort',
    orderCardBankCardOnSharedAccountOption: 'Bestill nytt kort til felleskonto',
    orderCardConfirmationTitle: 'Bekreft bestilling av bankkort',
    orderCardCreditCardOption: 'Søk om kredittkort',
    orderCardReplaceOption: 'Erstatt eksisterende kort',
    orderCardOptionsDescription:
        'Vi tilbyr trygge og sikre betalingsmidler - velg den korttypen som passer best til ditt behov',
    orderCardReplaceOptionDescription: 'Har du allerede kort hos oss?',
    orderCardReplaceConfirmationTitle: 'Bekreft erstatning av kort',
    orderCardReplaceConfirmationButton: 'Ja, bekreft erstatning',
    orderCardReplaceConfirmationDescriptionCardNumber: 'Du har valgt å erstatte kort med kortnummer {}.',
    orderCardReplaceConfirmationDescriptionReason: 'Årsak: {}.',
    orderCardReplaceNoCardsAvailable: 'Vi finner ingen kort du kan erstatte.',
    orderCardReplaceComplete: 'Kortet er erstattet',
    orderCardReplaceCompleteWithCardNumber: 'Kort med kortnummer {} er erstattet.',
    confirmChosenAccountNumber: 'Du har valgt å bestille et nytt kort til kontonummer',
    orderDebetCardConfirmation: 'Ja, bekreft bestilling',

    orderCardErrorText:
        'Vi beklager, men det har skjedd en feil med bestillingen din. Vennligst prøv igjen senere, eller ta kontakt med banken din for å fullføre bestillingen.',

    /* Debit Card Order */
    orderBankCard: 'Bestill kort',
    orderBankCardIngress: 'Her kan du sende bestilling av bankkort til valgt konto.',
    orderBankCardChooseAccount: 'Velg konto',
    orderBankCardButtonText: 'Send bestilling',
    orderBankCardSuccessText: 'Kortet er bestilt',
    orderBankCardFailureText: 'Noe gikk feil, vent litt og prøv igjen.',
    orderBankCardEmptyAccountList:
        'Vi fant dessverre ingen konto du kunne bestille kort på. Ta kontakt med banken din for å bestille.',
    orderBankCardInfoTextPart1:
        'Banken vil ta bestillingen din så fort som mulig og ta kontakt med deg hvis det er noen utfordringer.',
    orderBankCardInfoTextPart2: 'Hvis alt går bra kan du forvente å se kortet ditt i listen etter et par dager.',
    orderBankCardInfoTextPart3: 'Husk at det er årsgebyr på bankkort.',
    orderBankCardNoSuchAccount: 'Du kan ikke bestille et kort på dette kontonummeret.',
    orderBankCardConfirmationHeader: 'Er du sikker?',
    orderBankCardConfirmationAccount: 'Jeg ønsker å bestille kort på min konto: ',
    orderBankCardConfirmation: 'Ja, bestill kort',
    orderDebetCardConfirmationTitle: 'Bekreft bestilling',
    orderBankCardInfoTextExistingCard:
        'NB! Vær oppmerksom på hvilken konto du forsøker å bestille kort på. Dersom du allerede har et kort på konto, vises den ikke og du kan dessverre ikke bestille nytt kort her. Ta kontakt med banken for videre bistand.',
    orderBankCardMessageConfirmation: 'Er du sikker på at du ønsker å bestille et nytt bankkort til {} ({})?',
    orderDebetCardConfirmationDescription: 'Du har valgt å bestille et nytt bankkort til sparekonto ({}).',
    signingOrderNotCreatedError:
        'Fant ingen aktive signeringsoppdrag, vennligst prøv på nytt eller ta kontakt med kundeservice.',
    signingOrderFailedError: 'En feil oppstod under signering av avtaler. Vennligst ta kontakt med banken.',
    signingOrderCancelled: 'Signering av avtaler har blitt avbrutt.',
    signingOrderMissingError: 'Noe gikk galt.',
    signingOrderFailedWithRetryError:
        'En feil oppstod under signering av avtaler. Vennligst prøv på nytt eller ta kontakt med banken.',
    signingDocument: 'Signering av dokument',
    orderCardSigningPriorSummaryTextAccount: 'Det blir bestilt et kort til',
    orderCardToAccountText: 'på konto',
    orderCardSigningPriorSummaryTextSMS: 'Bekreftelse blir sendt på SMS til mobilnummer:',

    /* Credit Card Order */
    orderCreditCard: 'Bestill kort',

    orderCardAddressHeader: 'Kortet ditt blir sendt til:',
    orderCardAddressText: 'Kortet ditt blir sendt til adressen som står registrert i folkeregisteret.',
    sharedAccountOwnerText: 'Konto delt av',
};
